import {
	ChangeDetectionStrategy,
	Component,
	input,
	InputSignal,
	OnDestroy,
	signal,
	WritableSignal,
} from '@angular/core'
import { TuiDropdown, TuiDropdownManual } from '@taiga-ui/core'
import { Subject } from 'rxjs'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { TranslatePipe } from '@ngx-translate/core'
import { DropdownVariantEnum } from '@shared/enums/dropdown-variant.enum'
import { OrderInfoCardComponent } from '../../../actions/order-info-card/order-info-card.component'
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@Component({
	selector: 'app-filled-orders-actions',
	templateUrl: './filled-orders-actions.component.html',
	styleUrl: './filled-orders-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		OrderInfoCardComponent,
		TuiDropdown,
		TuiDropdownManual,
		TranslatePipe,
		ClickOutsideDirective,
		ButtonComponent,
	],
})
export class FilledOrdersActionsComponent implements OnDestroy {
	protected readonly dropdownVariantEnum: typeof DropdownVariantEnum = DropdownVariantEnum

	public order: InputSignal<OrderInterface | null> = input<OrderInterface | null>(null)

	private _destroy$: Subject<void> = new Subject<void>()

	protected openedDropdown: WritableSignal<DropdownVariantEnum | null> = signal(null)

	protected toggleDropdown(dropdown: DropdownVariantEnum | null): void {
		if (this.openedDropdown() === dropdown) {
			this.openedDropdown.set(null)
		} else {
			this.openedDropdown.set(dropdown)
		}
	}

	protected onClickOutside(): void {
		this.openedDropdown.set(null)
	}

	ngOnDestroy(): void {
		this._destroy$.next()
		this._destroy$.complete()
	}
}
